import { render } from "./Footer.vue?vue&type=template&id=6b8cd5a2"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6b8cd5a2&lang=css"

import exportComponent from "E:\\Andrei\\munca\\Isoletta\\isoletta-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__